export function bytesize(bytes: number, decimals: number = 2) {
  if (bytes === 0) return '0 B';
  const scale = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const dm = decimals <= 0 ? 0 : decimals;
  const i = Math.floor(Math.log(bytes) / Math.log(scale));
  if (!sizes[i]) return '0 B';
  return (bytes / Math.pow(scale, i)).toFixed(dm) + ' ' + sizes[i];
}

export function getBit(value: number, bit: number) {
  return (value >> bit) % 2;
}

export function testBit(value: number, bit: number) {
  return (value >> bit) % 2 !== 0;
}

export function toArray(list: FileList | File[]): File[] {
  return Array.prototype.slice.call(list || [], 0);
}

export function uriToFile(uri: string, name: string): Promise<File> {
  return new Promise((res, rej) => {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = () => res(new File(xhr.response, name));
    xhr.onerror = (e) => rej(e);
    xhr.open('GET', uri);
    xhr.send();
  });
}
